var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoDarkIconsvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4856",
    "data-name": "Path 4856",
    d: "M-256-114a1.139,1.139,0,0,1-1.167-1.167A1.139,1.139,0,0,1-256-116.333a1.139,1.139,0,0,1,1.167,1.167A1.139,1.139,0,0,1-256-114Zm-.833-10a.787.787,0,0,1,.833-.833.787.787,0,0,1,.833.833v5.917a.787.787,0,0,1-.833.833.787.787,0,0,1-.833-.833Zm.833-5a10.029,10.029,0,0,0-10,10,10.029,10.029,0,0,0,10,10,10.029,10.029,0,0,0,10-10,10.029,10.029,0,0,0-10-10Zm0,0",
    transform: "translate(266 129)",
    fill: "#f8f8f8",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDarkIconsvg);
export default __webpack_public_path__ + "static/media/info_dark_icon.svg.ede3a5938aa943b6f33913e5900aaa6b.svg";
export { ForwardRef as ReactComponent };